import type { ChangeEvent } from "react";
import { sortBy } from "lodash";
import { H6, Checkbox, Badge } from "orcs-design-system";
import { getGroupTypeBadgeVariant } from "src/util/group";

type GroupType = {
  id: string;
  name: string;
  styleVariant?: string;
  isSupply?: boolean;
};

type TeamTypeFilterSectionProps = {
  groupTypes: Record<string, GroupType> | undefined;
  defaultTeamTypes: string[];
  onToggleTeamType: (e: ChangeEvent<HTMLInputElement>) => void;
};

const TeamTypeFilterSection = ({
  groupTypes,
  defaultTeamTypes,
  onToggleTeamType,
}: TeamTypeFilterSectionProps) => (
  <>
    <H6 fontWeight="bold" my="s">
      Filter results by team type:
    </H6>
    {sortBy(Object.values(groupTypes || {}) as GroupType[], "name").map(
      (groupType) => (
        <Checkbox
          key={groupType.id}
          label={
            <Badge variant={getGroupTypeBadgeVariant(groupType)}>
              {groupType.name}
            </Badge>
          }
          name={groupType.id}
          checked={defaultTeamTypes.includes(groupType.id)}
          onChange={onToggleTeamType}
        />
      )
    )}
  </>
);

export default TeamTypeFilterSection;
